module.exports = __webpack_public_path__ + "img/t_herradura.77ab8653.svg";